"use strict";
exports.__esModule = true;
var user_verification_1 = require("./user-verification");
var Verifier = /** @class */ (function () {
    function Verifier(listOfUsers, selectedUser) {
        this.states = { INIT: 0, VALID: 1, EMPTY: 6, CONFLICT: 7, INVALID: 8 };
        this.activated = {};
        this.listOfUsers = listOfUsers;
        this.selectedUser = selectedUser;
        this.usernameState = this.states.INIT;
        this.emailState = this.states.INIT;
        this.groupState = this.states.INIT;
        this.phoneState = this.states.INIT;
    }
    Verifier.prototype.activate = function (element) {
        if (typeof element !== 'string') {
            return;
        }
        this.activated[element] = true;
    };
    Verifier.prototype.allValid = function () {
        var _this = this;
        if (this.selectedUser.username) {
            this.checkUsername();
        }
        if (this.selectedUser.email) {
            this.checkEmail();
        }
        if (this.selectedUser.groupname) {
            this.checkGroup();
        }
        var state = [
            this.usernameState,
            this.emailState,
            this.groupState,
        ];
        return state.filter(function (s) { return s !== _this.states.VALID; }).length === 0;
    };
    Verifier.prototype.checkUsername = function () {
        var username = this.selectedUser.username;
        if (!username) {
            this.usernameState = this.states.EMPTY;
        }
        else if (user_verification_1.usernameExists(this.listOfUsers, this.selectedUser)) {
            this.usernameState = this.states.CONFLICT;
        }
        else if (!user_verification_1.verifyUsername(username)) {
            this.usernameState = this.states.INVALID;
        }
        else {
            this.usernameState = this.states.VALID;
        }
    };
    Verifier.prototype.checkEmail = function () {
        var email = this.selectedUser.email;
        if (!email) {
            this.emailState = this.states.EMPTY;
        }
        else if (user_verification_1.emailExists(this.listOfUsers, this.selectedUser)) {
            this.emailState = this.states.CONFLICT;
        }
        else if (!user_verification_1.verifyEmail(email)) {
            this.emailState = this.states.INVALID;
        }
        else {
            this.emailState = this.states.VALID;
        }
    };
    Verifier.prototype.checkGroup = function () {
        var groupname = this.selectedUser.groupname;
        if (!groupname) {
            this.groupState = this.states.EMPTY;
        }
        else {
            this.groupState = this.states.VALID;
        }
    };
    return Verifier;
}());
exports.Verifier = Verifier;
//# sourceMappingURL=verifier.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/address-book2/verifier.js